module.exports = __webpack_public_path__ + "img/u_search.1c381da3.svg";